import React, { useState, useEffect } from "react";
import styled from "@emotion/styled";
import Map from "./map";
import VerticalTimeline from "./vertical-timeline";
import Blog from "./blog";
import Gallery, { LoadingAnimation } from "./gallery";

export default function({ events, countryName }) {
  return (
    <Container>
      {window.innerWidth > 600 && (
        <MapWrapper>
          <Map events={events} />
        </MapWrapper>
      )}

      <GalleryWrapper>
        <Gallery events={events} />
        <LoadingAnimation active={true} />
      </GalleryWrapper>

      <ContentWrapper>
        <TimelineWrapper>
          <VerticalTimeline events={events} />
        </TimelineWrapper>

        <BlogWrapper>
          <Blog events={events} countryName={countryName} />
        </BlogWrapper>
      </ContentWrapper>
    </Container>
  );
}

const Container = styled.div`
  height: 100vh;
  display: grid;
  grid-template-areas:
    "gallery  content"
    "map      content";
  grid-template-columns: 40vw 1fr;
  grid-template-rows: 50vh 1fr;
  overflow: hidden;

  @media (max-width: 600px) {
    height: auto;
    grid-template-areas:
      "gallery"
      "map"
      "content";
    grid-template-columns: 1fr;
    grid-template-rows: calc(100vw / 1.5) 0vh auto;
  }
`;

const GalleryWrapper = styled.div`
  grid-area: gallery;
  position: relative;
  @media (max-width: 600px) {
    position: fixed;
    z-index: 1;
    height: calc(100vw / 1.5);
    width: 100vw;
  }
`;

const MapWrapper = styled.div`
  grid-area: map;
  overflow: hidden;
  position: relative;
`;

const ContentWrapper = styled.div`
  grid-area: content;
  display: grid;
  grid-template-areas: "timeline blog";
  grid-template-columns: auto 1fr;
  margin-top: 4em;
  padding-right: 3em;
  @media (max-width: 600px) {
    grid-template-areas: "blog";
    grid-template-columns: auto;
    margin-top: 0em;
    padding-right: 0em;
    padding: 1em;
  }
`;

const BlogWrapper = styled.div`
  grid-area: blog;
`;

const TimelineWrapper = styled.div`
  grid-area: timeline;
  @media (max-width: 600px) {
    display: none;
  }
`;
